import { ButtonTab, ButtonTabs, useHasPermission, useIsAddonEnabled } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";
import styled from "styled-components";
import { shouldSkipPlannedCostStep } from "../../../../shared/events/save/eventStepperUtils";
import { EventDetailResource } from "../../shared/types";
import { ArchivedEventBanner } from "./ArchivedEventBanner";
import { EventCostsCard } from "./EventCostsCard";
import { EventOverviewCard } from "./EventOverviewCard";
import { EventParticipantsCard } from "./EventParticipantsCard";

const EventDetailsGrid = styled.div`
	display: grid;
	grid-template-columns: 400px 1fr;
	gap: ${({ theme }) => theme.spacing(5)};
`;

const EventInfoWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacing(5)};
`;

interface Props {
	event: EventDetailResource;
}

export const ArchivedEventOverview: FC<Props> = ({ event }) => {
	const { t } = useTranslation();
	const isPressModuleEnabled = useIsAddonEnabled("pressModule");
	const isContactDatabaseEnabled = useIsAddonEnabled("contactDatabase");
	const canReadContacts = useHasPermission(["contact.read"]);
	const canReadClippingProviderContacts = useHasPermission(["clippingProviderContact.read"]);

	return (
		<>
			<ArchivedEventBanner id={event.id} />
			<EventDetailsGrid>
				<EventInfoWrapper>
					<EventOverviewCard event={event} isArchived={true} />
					{event.eventType.plannedPersonCountRequirement !== "prohibited" && isContactDatabaseEnabled && (
						<EventParticipantsCard event={event} />
					)}
					{!shouldSkipPlannedCostStep(event.eventType) &&
						isContactDatabaseEnabled &&
						event.hasProjectMemberPermissions && <EventCostsCard event={event} />}
				</EventInfoWrapper>
				<EventInfoWrapper>
					<ButtonTabs>
						<ButtonTab to="../details">{t("Details")}</ButtonTab>
						{isContactDatabaseEnabled && canReadContacts && <ButtonTab to="../contacts">{t("Contacts")}</ButtonTab>}
						{isContactDatabaseEnabled && isPressModuleEnabled && canReadClippingProviderContacts && (
							<ButtonTab to="../clipping-provider-contacts">{`${t("Contacts")} (${t("Clipping provider")})`}</ButtonTab>
						)}
					</ButtonTabs>
					<Outlet />
				</EventInfoWrapper>
			</EventDetailsGrid>
		</>
	);
};
